/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFireFlameCurved} from '@fortawesome/pro-solid-svg-icons';

const DataForgeIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faFireFlameCurved} {...props} />
);

export default DataForgeIcon;
